import createLucideIcon from '../createLucideIcon';

const CornerLeftDown = createLucideIcon('CornerLeftDown', [
  ['polyline', { points: '14 15 9 20 4 15', key: 'nkc4i' }],
  ['path', { d: 'M20 4h-7a4 4 0 0 0-4 4v12', key: 'nbpdq2' }],
]);

export default CornerLeftDown;
